import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import {
  FDHeadlineText, FDBodyText,
} from '@facet-wealth/design';
import { withComponentArray } from 'Helpers/MetaOverride';
import { Disclosure } from '../Components/Disclosure';


export default buildFacetDesignOverride()

  .nameOverride('title', {
    _component: () => FDHeadlineText,
    _customProps: {
      size: 'lg',
      color: 'textSecondary',
    },
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => withComponentArray(FDBodyText),
    _customProps: {
      size: 'lg',
    },
  }, overrideReadOnly)
  .nameOverride('body', {
    _component: () => withComponentArray(FDBodyText),
  }, overrideReadOnly)
  .nameOverride('outstandingRmdCopy', {
    _component: () => Disclosure,
    _customProps: {
      status: 'warning',
    },
  }, overrideReadOnly);
